export function concatenateUrl(baseUrl: string, relativePath: string): string {
	// Remove trailing slash from baseUrl if present
	baseUrl = baseUrl.replace(/\/+$/, "");

	// Remove leading slash from relativePath if present
	relativePath = relativePath.replace(/^\/+/, "");

	return `${baseUrl}/${relativePath}`;
}
